<template>
	<div class="file-wrapper" @dragover="dragover" @dragleave="dragleave" @drop="drop">
		<input
			type="file"
			ref="file"
			class="display-hidden"
			:id="targetId"
			:name="targetName || targetId"
			:accept="accept"
			@change="handleChange"
			:multiple="multiple"
		/>
		<label :for="targetId" v-if="isVisible">{{ labelText }}</label>
	</div>
</template>

<script>
export default {
	name: 'FileInputDrag',
	props: ['targetId', 'targetName', 'accept', 'label', 'visible', 'onChange', 'multiple'],
	computed: {
		labelText: function() {
			return this.label || '이곳을 클릭해주세요';
		},
		isVisible: function() {
			return typeof this.visible === 'undefined' ? true : this.visible;
		},
	},
	methods: {
		handleChange: function() {
			var etcMaxSize = 100 * 1024 * 1024;
			var imageMaxSize = 25 * 1024 * 1024;
			var fileType = this.$refs.file.files[0].type;

			console.log('fileType :: ', fileType);

			if (fileType === 'image/png' || fileType === 'image/jpg' || fileType === 'image/jpeg' || fileType === 'image/gif') {
				if (this.$refs.file.files[0].size > imageMaxSize) {
					alert('첨부파일은 25MB를 초과할 수 없습니다.');
					return false;
				}
			} else if (fileType === 'application/zip' || fileType === 'application/pdf') {
				if (this.$refs.file.files[0].size > etcMaxSize) {
					alert('첨부파일은 100MB를 초과할 수 없습니다.');
					return false;
				}
			}

			if (this.onChange) this.onChange(this.$refs.file);
		},
		dragover(e) {
			e.preventDefault();
			//if (!e.currentTarget.classList.contains('bg-green-300')) {
			//	e.currentTarget.classList.remove('bg-gray-100');
			//	e.currentTarget.classList.add('bg-green-300');
			//}
		},
		dragleave() {
			// Clean up
			//e.currentTarget.classList.add('bg-gray-100');
			//e.currentTarget.classList.remove('bg-green-300');
		},
		drop(e) {
			e.preventDefault();
			this.$refs.file.files = e.dataTransfer.files;
			if (this.onChange) this.onChange(this.$refs.file);
			//e.currentTarget.classList.add('bg-gray-100');
			//e.currentTarget.classList.remove('bg-green-300');
		},
	},
};
</script>

<style scoped></style>
